import httpClient from '@/libs/http-client'
import { encrypt } from '@/libs/utils'

export function signIn (params) {
  const url = '/ut/user/login'
  params.password = encrypt(params.password, params.username)

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function refreshToken (token) {
  const url = '/auth/refresh'
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }

  return httpClient.post(url, {}, config).then(response => {
    return response.data.result
  })
}

export function getUserInfo (config = {}) {
  const url = '/user/get_info'

  return httpClient.post(url, {}, config).then(response => {
    return response.data.result
  })
}
